import comments from "./module/comments";
import home from "./module";
import search from "./module/search";

const en = {
  // 引入自己定义的模块
  home: home.en,
  comments: comments.en,
  search: search.en,
};
export default en;


// WEBPACK FOOTER //
// ./src/language/en.js